export default __webpack_public_path__ + "92a5a66fed939ee38141a4c39cc9967a.png";